import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Container } from "reactstrap"
import {
  getTheoreticalAssessmentQuestions,
  submitTheoreticalParticipantAssessment,
} from "store/actions/theoreticalTrainingAction"
import { showAlert } from "store/reducers/alertReducer"
import DeleteModal from "components/Common/DeleteModal"

const StartAssessment = ({ selectedItem, toggle1, getAllData }) => {
  const { t } = useTranslation()
  const {
    loadingInterviewQ,
    theoreticalAssessmentQuestions,
    isLoading,
    assessmentAllowedTime,
  } = useSelector(state => state.TheoreticalTraining)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [timeLeft, setTimeLeft] = useState(null) // 2 minutes in seconds
  const [activeButtons, setActiveButtons] = useState({}) // Track selected options
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  useEffect(() => {
    getQAData()
  }, [])

  // useEffect(() => {
  //   if (assessmentAllowedTime) setTimeLeft(assessmentAllowedTime)
  // }, [assessmentAllowedTime])

  // useEffect(() => {
  //   const timerId = setInterval(() => {
  //     if (timeLeft !== 0) {
  //       setTimeLeft(timeLeft - 1)
  //     }
  //   }, 1000)
  //   return () => clearInterval(timerId)
  // }, [timeLeft])

  const getQAData = () => {
    dispatch(getTheoreticalAssessmentQuestions())
  }

  const [selectedAnswers, setSelectedAnswers] = useState({})

  const handleOptionSelect = (questionId, optionId) => {
    setSelectedAnswers(prev => ({
      ...prev,
      [questionId]: { optionId },
    }))
  }

  // const formatTime = seconds => {
  //   const isNegative = seconds < 0 // Check if time is negative
  //   const absoluteSeconds = Math.abs(seconds) // Work with absolute value for calculation
  //   const mins = Math.floor(absoluteSeconds / 60)
  //   const secs = absoluteSeconds % 60
  //   return `${isNegative ? "-" : ""}${mins}:${secs < 10 ? "0" : ""}${secs}`
  // }

  const preparePayload = () => {
    if (
      // timeLeft > 0 &&
      theoreticalAssessmentQuestions[0].questions.length !=
      Object.entries(selectedAnswers).length
    ) {
      return dispatch(
        showAlert({ text: t("Please answer all questions"), type: "error" })
      )
    }

    // timeLeft === 0 && Object.entries(selectedAnswers).length === 0
    //   ? theoreticalAssessmentQuestions.map(quiz => ({
    //       quizz_id: quiz.id, // Dynamically get quizz_id from response
    //       questions: quiz.questions.map(question => {
    //         return {
    //           question_id: question.id,
    //           option_id: 0,
    //         }
    //       }),
    //     })):
    const assessments = theoreticalAssessmentQuestions.map(quiz => ({
      quizz_id: quiz.id, // Dynamically get quizz_id from response
      questions: Object.entries(selectedAnswers).map(
        ([question_id, { optionId }]) => ({
          question_id: Number(question_id),
          option_id: optionId,
        })
      ),
    }))

    const payload = {
      time_taken: 0,
      participant_uuid: selectedItem?.participant_uuid,
      assessments,
    }

    return payload
  }

  // useEffect(() => {
  //   if (timeLeft === 0) {
  //     handleEndInterview()
  //   }
  // }, [timeLeft])

  const handleEndInterview = () => {
    setShowConfirmationModal(false)
    const data = preparePayload()

    dispatch(submitTheoreticalParticipantAssessment(data))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggle1()
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div className="">
      {loadingInterviewQ ? (
        <Spinners />
      ) : (
        <Container fluid>
          <div className="candidate_interview_container">
            {/* <h2 className="d-flex align-items-end justify-content-end text-primary">
              {t("Time Left")} {formatTime(timeLeft)}
            </h2> */}
            <div className="right">
              <div className="questions_container">
                {theoreticalAssessmentQuestions.map((category, catIndex) => (
                  <div className="q_single" key={catIndex}>
                    <h3 className="title">{category.qn_category}</h3>
                    {category.questions.map((question, qIndex) => (
                      <div className="question" key={question.id}>
                        <div className={`q_left ${question.type}`}>
                          <h4>
                            {qIndex + 1}. {question.question}
                          </h4>
                        </div>
                        <div className="q_right">
                          <div className="button_group">
                            {question.options.map((option, optionIndex) => (
                              <label key={option.id} className="radio_label">
                                <span className="option_label">
                                  {String.fromCharCode(65 + optionIndex)}.{" "}
                                </span>
                                <input
                                  type="radio"
                                  disabled={timeLeft === 0}
                                  name={`question_${question.id}`} // Ensures only one selection per question
                                  value={option.id}
                                  checked={
                                    selectedAnswers[question.id]?.optionId ===
                                    option.id
                                  }
                                  onClick={() =>
                                    handleOptionSelect(question.id, option.id)
                                  }
                                />

                                {option.option}
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className="action_btn">
                <button
                  className="theme_btn"
                  style={{ marginRight: "8px" }}
                  disabled={isLoading}
                  // onClick={() => setShowConfirmationModal(true)}
                  onClick={toggle1}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="theme_btn fill"
                  onClick={handleEndInterview}
                  disabled={isLoading}
                >
                  {t("Submit")}
                </button>
              </div>
            </div>
          </div>
        </Container>
      )}
      {/* <DeleteModal
        bodyTitle={t("If you cancel, the assessment will be auto submitted!")}
        show={showConfirmationModal}
        buttonText={t("Leave")}
        onCloseClick={() => setShowConfirmationModal(false)}
        onDeleteClick={() => {
          setTimeLeft(0)
          // handleEndInterview()
        }}
      /> */}
    </div>
  )
}

export default StartAssessment
